// extracted by mini-css-extract-plugin
module.exports = {"counter":"_14geO_j00-b0wT9T2Sf31s"};